import React, { useState, useRef } from "react";
import { Modal, Button, Input, Badge, Avatar, Tooltip } from "antd";
import {
  setDuplicateDashboardFlag,
  setDuplicateTemplate,
} from "../../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import {
  deepCopy,
  getGlobalFilterAndFilterCountObject,
  getPaneIndex,
  getTemplateListBasicObject,
  removeHiddenFromSaved,
  removePrivateConversationFilters,
} from "../../../../redux/constants";
import { memo } from "react";
import filterSmall from "../../../../assets/filterIcon.svg";
import filterSmallWhite from "../../../../assets/WhiteIcons/filterIconWhite.svg";
import { setSelectedPillInPane } from "../../../../redux/actions/dashboard/Tab1";

const { TextArea } = Input;

const SaveAsModal = ({ isModalSaveAs, setIsModalSaveAs }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();

  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const duplicateDashboardLoader = useSelector(
    (state) => state.ApiCall.duplicateDashboardLoader
  );
  const All_Share_attributes = useSelector(
    (state) => state.WidgetMaker.All_Share_attributes
  );
  let index = getPaneIndex(panes, activeKey);

  const globalFinalFilter = getGlobalFilterAndFilterCountObject(
    "view_dashboard",
    deepCopy(panes[index]),
    graphConditionConfig
  );

  const [flag, setflag] = useState(false);
  const [dashboardName, setDashboardName] = useState(
    panes?.[index]?.template_name + " - " + "With Filters"
  );
  const [dashboardDescription, setDashboardDescription] = useState(
    panes?.[index]?.template_description
  );
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const shareableData = useSelector((state) => state.dashboard.shareableData);

  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));
  const selectedPill = panes[index]?.selected_pills
    ? panes[index]?.selected_pills
    : [];
  if (selectedPill?.[0]?.saved_filters?.length) {
    globalFinalFilter.filters = removeHiddenFromSaved(
      deepCopy(globalFinalFilter.filters),
      deepCopy(selectedPill?.[0]?.saved_filters)
    );
    globalFinalFilter.count = globalFinalFilter.filters?.length;
  }

  const handleCancel = () => {
    setIsModalSaveAs(false);
    setDashboardName(panes?.[index]?.template_name + " - " + "With Filters");
    setDashboardDescription(panes?.[index]?.template_description);
    dispatch(setDuplicateDashboardFlag(false));
  };

  const handleSaveAsDashboard = (e) => {
    const selectedPill = panes[index]?.selected_pills
      ? panes[index]?.selected_pills
      : [];
    if (selectedPill?.[0]?.saved_filters?.length) {
      panes[index].filters = removeHiddenFromSaved(
        deepCopy(panes?.[index]?.filters),
        deepCopy(selectedPill?.[0]?.saved_filters)
      );
      dispatch(setSelectedPillInPane({}, index, panes));
    }
    if (dashboardName) {
      let basicObj = getTemplateListBasicObject(
        authParams,
        panes,
        index,
        pageSize,
        graphConditionConfig
      );
      let notMatchedFilters = removePrivateConversationFilters(
        panes?.[index]?.comp_hidden_filter,
        panes?.[index]?.filters,
        panes?.[index]?.saved_filters
      );

      let obj = {
        template_id: panes?.[index]?.template_id,
        template_name: dashboardName,
        template_description: dashboardDescription,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
        panes: panes,
        activeKey: activeKey,
        filters:
          panes?.[index]?.template_type === "competition"
            ? notMatchedFilters?.length
              ? notMatchedFilters
              : []
            : panes?.[index]?.filters?.length
            ? panes?.[index]?.filters
            : [],
        saveAsFlag: true,
        // pass
        index: index,
        firstSection: true,
        templateDetails: templateDetails,
        singleBrands: Allbrands,
        global_dashboard_duration: global_dashboard_duration,
        competitorBrands: competitorBrands,
        graphConditionConfig: graphConditionConfig,
        temporary_words: temporary_words,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
        authParams: authParams,
        Allbrands: Allbrands,
        brandlogicalgroup: brandlogicalgroup,
        global_dashboard_single_brands: global_dashboard_single_brands,
        global_dashboard_brands: global_dashboard_brands,
      };
      dispatch(setDuplicateTemplate(basicObj, obj));
    }
  };

  const handleDashboardName = (e) => {
    setflag(true);
    setDashboardName(e.target.value);
  };

  const handleDashboardDescription = (e) => {
    setflag(true);
    setDashboardDescription(e.target.value);
  };

  return (
    <Modal
      title={
        <div className="d-flex justify-content-between">
          Save As Dashboard
          <div>
            {globalFinalFilter?.filters?.length ? (
              <Tooltip
                overlayStyle={{
                  width:
                    panes[index] &&
                    panes[index]?.filters?.length > 0 &&
                    panes[index]?.filters?.findIndex((el) => {
                      return !graphConditionConfig?.[
                        `quick-filter-keys`
                      ]?.includes(el?.attribute);
                    }) !== -1 &&
                    "20rem",
                }}
                // color="#3B5175"
                title={
                  globalFinalFilter?.filters?.length > 0 ? (
                    <div
                      className="custom_scroll"
                      style={{
                        maxWidth: "27rem",
                        maxHeight: "23rem",
                        overflow: "auto",
                        scrollBehavior: "smooth",
                      }}
                    >
                      <div className="mb-1">
                        {globalFinalFilter?.filters?.map((el) => {
                          let data =
                            panes[index]?.filterPanelData?.[el?.attribute]
                              ?.values;

                          return !(
                            panes[index]?.template_id === "000-000-002" ||
                            panes[index]?.template_id === "000-000-003"
                          ) ? (
                            globalFinalFilter?.filters?.length ? (
                              <div className="mb-2">
                                <p
                                  className="mb-0"
                                  style={{
                                    color:
                                      el?.type === "include"
                                        ? "#5ed66d"
                                        : el?.type === "exclude" && "#fb7665",
                                  }}
                                >
                                  <strong>
                                    {All_Share_attributes
                                      ? All_Share_attributes?.[el?.attribute]
                                        ? All_Share_attributes?.[el?.attribute]
                                        : el?.attribute?.toLowerCase() ===
                                          "categoryid"
                                        ? "Category"
                                        : el?.attribute?.toLowerCase() ===
                                          "subcategoryid_aug"
                                        ? "Sub Category"
                                        : el?.attribute?.toLowerCase() ===
                                          "subsubcategoryid"
                                        ? "Sub Sub Category"
                                        : el?.attribute?.endsWith("ID")
                                        ? el?.attribute?.replace("ID", "")
                                        : el?.attribute?.replace("Type", "")
                                      : el?.attribute?.endsWith("ID")
                                      ? el?.attribute?.replace("ID", "")
                                      : el?.attribute?.replace("Type", "")}
                                  </strong>
                                </p>
                                {el?.type === "int" &&
                                  !Array.isArray(el?.columns) && (
                                    <span className="font-weight-light text-white">
                                      {el?.columns?.from +
                                        " - " +
                                        el?.columns?.to}
                                    </span>
                                  )}
                                {Array.isArray(el?.columns) &&
                                  el?.columns?.map((e, index) => {
                                    return (
                                      <span
                                        className="font-weight-light"
                                        style={{
                                          color:
                                            e?.type === "include"
                                              ? "#5ed66d"
                                              : e?.type === "exclude" &&
                                                "#fb7665",
                                        }}
                                      >
                                        {(index ? ", " : "") +
                                          (e?.display_name
                                            ? e?.display_name
                                            : e?.name)}
                                      </span>
                                    );
                                  })}
                              </div>
                            ) : (
                              "Filter"
                            )
                          ) : (
                            <div className="mb-2">
                              <p className="mb-0 text-white">
                                <strong>
                                  {panes[index]?.template_id ===
                                    "000-000-003" &&
                                  el?.attribute === "IsWorkingHour"
                                    ? "Is Working Hour"
                                    : All_Share_attributes &&
                                      All_Share_attributes[el?.attribute]
                                    ? All_Share_attributes[el?.attribute]
                                    : panes[index]?.filterPanelData
                                    ? panes[index]?.filterPanelData?.[
                                        el?.attribute
                                      ]?.title
                                    : el?.attribute?.toLowerCase() ===
                                      "categoryid"
                                    ? "Category"
                                    : el?.attribute?.toLowerCase() ===
                                      "subcategoryid_aug"
                                    ? "Sub Category"
                                    : el?.attribute?.toLowerCase() ===
                                      "subsubcategoryid"
                                    ? "Sub Sub Category"
                                    : el?.attribute?.replace("Type", "")}
                                </strong>
                              </p>
                              {Array.isArray(el?.columns) &&
                                el?.columns?.map((e, index) => {
                                  return (
                                    <span
                                      className="font-weight-light"
                                      style={{
                                        color:
                                          e?.type === "include"
                                            ? "#5ed66d"
                                            : e?.type === "exclude" &&
                                              "#fb7665",
                                      }}
                                    >
                                      {[
                                        "FeedBackEnabled",
                                        "ShowDeletedFromSocial",
                                        "AutoClosureEnabled",
                                        "IsWorkingHour",
                                      ]?.includes(el?.attribute)
                                        ? e?.name === null
                                          ? "Any"
                                          : e?.name === 0
                                          ? "No"
                                          : e?.name === 1 && "Yes"
                                        : (index ? ", " : "") +
                                          data?.filter(
                                            (g) => e?.name === g?.id
                                          )[0]?.name}
                                    </span>
                                  );
                                })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    "Filter"
                  )
                }
                placement="leftTop"
              >
                <Badge
                  style={{ backgroundColor: "#185edf", fontSize: "1rem" }}
                  size="small"
                  count={
                    globalFinalFilter?.filters
                      ? globalFinalFilter?.filters?.length
                      : 0
                  }
                >
                  <Avatar
                    shape="square"
                    size="small"
                    src={
                      authParams?.theme_type === "1"
                        ? filterSmallWhite
                        : filterSmall
                    }
                    alt="Header Filter"
                  />
                </Badge>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        </div>
      }
      visible={isModalSaveAs}
      onOk={handleSaveAsDashboard}
      onCancel={handleCancel}
      footer={[
        <Button type="button" className="btn_Clear" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={handleSaveAsDashboard}
          style={{
            pointerEvents:
              dashboardName === null
                ? "none"
                : dashboardName?.trim().length === 0
                ? "none"
                : "auto",
            opacity:
              dashboardName === null
                ? "0.5"
                : dashboardName?.trim().length === 0
                ? "0.5"
                : "1",
          }}
          loading={duplicateDashboardLoader ? true : false}
        >
          Save
        </Button>,
      ]}
      width={550}
      closable={false}
      maskClosable={false}
      className={
        authParams?.theme_type === "1" ? "formModal darkTheme" : "lightTheme"
      }
    >
      <div className="w-100">
        <div className="position-relative floating-label-group header-brands mb-15">
          <Input
            required
            id="outlined-required"
            inputRef={inputRef}
            maxLength={100}
            InputLabelProps={{
              shrink:
                dashboardName && dashboardName?.trim().length > 0
                  ? true
                  : false,
            }}
            value={dashboardName}
            error={flag && dashboardName?.trim()?.length === 0}
            onChange={(e) => handleDashboardName(e)}
            className="border-radius-4 border-color"
          />
          {flag && dashboardName?.trim()?.length === 0 && (
            <span className="error">Dashboard name cannot be empty *</span>
          )}
          <label className="portlet-label floating-label">
            Enter new dashboard name
          </label>
          <span
            className="text-gray position-absolute font-size12"
            style={{
              right: "0.3rem",
              bottom: "0.1rem",
            }}
          >
            {dashboardName?.length > 0 ? dashboardName?.length : "0"}/100
          </span>
        </div>

        <div className="position-relative mt-15 floating-label-group header-brands">
          <TextArea
            rows={4}
            id="outlined-required"
            inputRef={inputRef}
            maxLength={150}
            InputLabelProps={{
              shrink:
                dashboardDescription && dashboardDescription?.trim().length > 0
                  ? true
                  : false,
            }}
            value={dashboardDescription}
            onChange={(e) => handleDashboardDescription(e)}
            className="border-radius-4 border-color pt-2"
            style={{ resize: "none" }}
          />
          <label className="portlet-label floating-label line-height-normal">
            Enter new dashboard description
          </label>
          <span
            className="text-gray position-absolute font-size12"
            style={{
              right: "0.3rem",
              bottom: "0.1rem",
            }}
          >
            {dashboardDescription?.length > 0
              ? dashboardDescription?.length
              : "0"}
            /150
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default memo(SaveAsModal);
